export default [
    {label: 'Identity Card', value: 'IC'},
    {label: 'Passport', value: 'PPT'}
]